import { render, staticRenderFns } from "./newbuilding.vue?vue&type=template&id=73ef1524&scoped=true&"
import script from "./newbuilding.vue?vue&type=script&lang=js&"
export * from "./newbuilding.vue?vue&type=script&lang=js&"
import style0 from "./newbuilding.vue?vue&type=style&index=0&id=73ef1524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ef1524",
  null
  
)

export default component.exports